import React, { FC, useEffect } from "react";
import { FactorEnum, TFactor } from "../../../models/Factors";
import { TextField } from "mui-rff";
import { Typography } from "@mui/material";
import { ResendFactor } from "../ResendFactor";
import { PasswordChange } from "../../../components/PasswordChange";

export const FactorForm: FC<{
  currentFactor: TFactor;
  code: string;
  setCode: React.Dispatch<React.SetStateAction<string>>;
  onResend: () => Promise<void>;
  onIsReadyChange?: (ready: boolean) => void;
}> = ({
  currentFactor: { factorType, factorInfoMasked },
  code,
  setCode,
  onResend,
  onIsReadyChange,
}) => {
    const renderFactorForm = () => {
      switch (factorType) {
        case FactorEnum.Password:
          return (
            <TextField
              label='Password'
              placeholder='Enter your password'
              helperText={`Please enter the password you set in your profile`}
              name='code'
              value={code}
              required={true}
              size='small'
              margin='normal'
              type='password'
              autoFocus
              inputProps={{
                onChange: (e: any) => {
                  setCode(e.target.value);
                },
              }}
            />
          );

        case FactorEnum.SmsCode:
        case FactorEnum.EmailCode:
          return (
            <>
              <Typography variant='body1'>
                {factorInfoMasked
                  ? `We sent a code ${factorType === FactorEnum.EmailCode
                    ? "to the email "
                    : "via SMS to the phone number "
                  } '${factorInfoMasked}'`
                  : "We sent a code to your email"}
              </Typography>
              <TextField
                key={factorType}
                value={code}
                label='Verification Code'
                name='code'
                required={true}
                size='small'
                margin='normal'
                autoFocus
                inputProps={{
                  onChange: (e: any) => {
                    setCode(e.target.value);
                  },
                }}
              />
              <ResendFactor onResend={onResend} />
            </>
          );

        case FactorEnum.SetPassword:
          return (
            <PasswordChange
              askCurrentPassword={false}
              onNewPasswordChange={(value) => {
                setCode(value);
              }}
              onIsReadyChange={(isReady) => {
                onIsReadyChange?.(isReady);
              }}
            />
          );

        default:
          return (
            <Typography variant='body1' color='error'>
              Sorry, try again later.
            </Typography>
          );
      }
    };

    return <>{renderFactorForm()}</>;
  };
